import React from "react";
import { useSelector } from "react-redux";
import { getMerchantConfig, getRmsConfig } from "features/config/configSlice";

function Quantity({ quantityInc, setQuantityInc, originalQuantity }) {
  const rmsConfig = useSelector(getRmsConfig);
  const merchantConfig = useSelector(getMerchantConfig);

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        margin: "1rem 0px",
      }}
    >
      <p
        style={{
          color: "#3B444D",
          fontSize: "16px",
          marginRight: rmsConfig.supports_return_partial_qtty ? "20px" : "6px",
        }}
      >
        Quantity to be returned:{" "}
      </p>
      {rmsConfig.supports_return_partial_qtty ? (
        <div style={{ display: "flex" }}>
          <button
            disabled={
              !rmsConfig.supports_return_partial_qtty || quantityInc === 1
            }
            style={{
              background:
                merchantConfig.merchant_id === 977
                  ? "#F9FAFC"
                  : `${merchantConfig.primary_theme_color}15`,
              border:
                merchantConfig.merchant_id === 977
                  ? "1px solid #E3E6EE"
                  : `1px solid ${merchantConfig.primary_theme_color}22`,
              borderTopLeftRadius: merchantConfig.use_rounded_edge_buttons
                ? "10px"
                : "0px",
              borderBottomLeftRadius: merchantConfig.use_rounded_edge_buttons
                ? "10px"
                : "0px",
              width: "35px",
              height: "35px",
              fontSize: "16px",
              cursor: "pointer",
              color:
                !rmsConfig.supports_return_partial_qtty || quantityInc === 1
                  ? "#3B444D33"
                  : merchantConfig.primary_theme_color,
            }}
            onClick={() => {
              if (quantityInc > 0) {
                setQuantityInc(quantityInc - 1);
              }
            }}
          >
            &#8212;
          </button>
          <button
            style={{
              borderTop:
                merchantConfig.merchant_id === 977
                  ? "1px solid #E3E6EE"
                  : `1px solid ${merchantConfig.primary_theme_color}22`,
              borderBottom:
                merchantConfig.merchant_id === 977
                  ? "1px solid #E3E6EE"
                  : `1px solid ${merchantConfig.primary_theme_color}22`,
              borderLeft: "none",
              borderRight: "none",
              width: "35px",
              height: "35px",
              background:
                merchantConfig.merchant_id === 977
                  ? "#F9FAFC"
                  : `${merchantConfig.primary_theme_color}15`,
              color: "#3B444D",
              fontSize: "16px",
            }}
          >
            {quantityInc}
          </button>
          <button
            disabled={
              !rmsConfig.supports_return_partial_qtty ||
              quantityInc === originalQuantity
            }
            style={{
              border:
                merchantConfig.merchant_id === 977
                  ? "1px solid #E3E6EE"
                  : `1px solid ${merchantConfig.primary_theme_color}22`,
              width: "35px",
              height: "35px",
              fontSize: "24px",
              cursor: "pointer",
              color:
                !rmsConfig.supports_return_partial_qtty ||
                quantityInc === originalQuantity
                  ? "#3B444D33"
                  : merchantConfig.primary_theme_color,
              background:
                merchantConfig.merchant_id === 977
                  ? "#F9FAFC"
                  : `${merchantConfig.primary_theme_color}15`,
              borderTopRightRadius: merchantConfig.use_rounded_edge_buttons
                ? "10px"
                : "0px",
              borderBottomRightRadius: merchantConfig.use_rounded_edge_buttons
                ? "10px"
                : "0px",
                
            }}
            onClick={() => {
              setQuantityInc(quantityInc + 1);
            }}
          >
            +
          </button>
        </div>
      ) : (
        <p style={{ color: merchantConfig.primary_theme_color }}>
          {quantityInc}
        </p>
      )}
    </div>
  );
}

export default Quantity;
